import setHiddenSlides from '../../../../src/js/set-hidden-slides';
import removeUnnecessaryAriaAttr from '../../../../src/js/remove-unnecessary-aria-attr';

// eslint-disable-next-line no-undef
new Swiper('.block-case-studies-slider__slides', {
	a11y: {
		slideLabelMessage: 'slide {{index}} of {{slidesLength}}',
	},
	on: {
		init: setHiddenSlides,
		afterInit: removeUnnecessaryAriaAttr,
		slideChangeTransitionEnd: setHiddenSlides,
		breakpoint: setHiddenSlides,
	},
	slidesPerView: 1,
	loop: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: false,
	},
	navigation: {
		nextEl: '.block-case-studies-slider-arrows__next',
		prevEl: '.block-case-studies-slider-arrows__prev',
	},
});
